import React, { useState } from 'react';
import './Govindas.css';
import LazyImage from '../components/LazyImage'; // Add this line

import food1 from '../assets/images/govindas/food1.jpeg';
import food4 from '../assets/images/govindas/food4.jpeg';
import party1 from '../assets/images/govindas/party1.jpeg';
import party2 from '../assets/images/govindas/party2.jpeg';
import interior1 from '../assets/images/govindas/interior1.jpeg';
import interior2 from '../assets/images/govindas/interior2.jpeg';
import interior3 from '../assets/images/govindas/interior3.jpeg';
import interior4 from '../assets/images/govindas/interior4.jpeg';


const imageData = [
    
 
    { url: interior1 ,  category: 'Ambience' },
    { url: interior2 ,  category: 'Ambience' },
    { url: interior3 ,  category: 'Ambience' },
    { url: interior4 ,  category: 'Ambience' },
    { url: food4, category: 'Food' },
    { url: food1, category: 'Food' },
    { url: party1, category: 'Party' },
    { url: party2, category: 'Party' },
];

const categories = ['All', 'Ambience', 'Party', 'Food'];

const Govindas = () => {
    const [filter, setFilter] = useState('All');

    const filteredImages = filter === 'All'
        ? imageData
        : imageData.filter(img => img.category === filter);

    return (
        <div className="govindas-page">
            <h2 className="text-center">Govindas Restaurant</h2>
            <p className="description text-center">
                The Govinda’s Restaurant is world class and truly the best vegetarian multi-cuisine restaurant in Ujjain. It offers the best quality food which is not only purely vegetarian, onion and garlic free but also spiritualized by being offered to Krishna
            </p>
            <p className="text-center"><strong>For booking & details Please contact:</strong></p>
            <p className="text-center"><strong>Phone (Reception): +91 9669055560</strong></p>
            <p className="text-center"><strong>Email: govindas@iskconujjain.com</strong></p>

            <div className="text-center">
                {categories.map(cat => (
                    <button
                        key={cat}
                        className={`filter-btn ${filter === cat ? 'active' : ''}`}
                        onClick={() => setFilter(cat)}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            <div className="image-grid">
                {filteredImages.map((img, index) => (
                    <div key={index} className="image-box">
                        <LazyImage src={img.url} alt={img.category} className="govinda-image" />
                    </div>
                ))}
            </div>
        </div >
    );
};

export default Govindas;
